/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { identGetEntities } from '../fn/ident/ident-get-entities';
import { IdentGetEntities$Params } from '../fn/ident/ident-get-entities';
import { identGetEntityFiles } from '../fn/ident/ident-get-entity-files';
import { IdentGetEntityFiles$Params } from '../fn/ident/ident-get-entity-files';
import { PersonEntities } from '../models/person-entities';
import { QueryResultOfIEnumerableOfEntityFileInfo } from '../models/query-result-of-i-enumerable-of-entity-file-info';

@Injectable({ providedIn: 'root' })
export class IdentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `identGetEntities()` */
  static readonly IdentGetEntitiesPath = '/ident/r_entities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identGetEntities()` instead.
   *
   * This method doesn't expect any request body.
   */
  identGetEntities$Response(params?: IdentGetEntities$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonEntities>> {
    return identGetEntities(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identGetEntities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identGetEntities(params?: IdentGetEntities$Params, context?: HttpContext): Observable<PersonEntities> {
    return this.identGetEntities$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonEntities>): PersonEntities => r.body)
    );
  }

  /** Path part for operation `identGetEntityFiles()` */
  static readonly IdentGetEntityFilesPath = '/ident/entity_files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identGetEntityFiles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identGetEntityFiles$Response(params: IdentGetEntityFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryResultOfIEnumerableOfEntityFileInfo>> {
    return identGetEntityFiles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identGetEntityFiles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identGetEntityFiles(params: IdentGetEntityFiles$Params, context?: HttpContext): Observable<QueryResultOfIEnumerableOfEntityFileInfo> {
    return this.identGetEntityFiles$Response(params, context).pipe(
      map((r: StrictHttpResponse<QueryResultOfIEnumerableOfEntityFileInfo>): QueryResultOfIEnumerableOfEntityFileInfo => r.body)
    );
  }

}
